var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomersproducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.14 46.1a6 6 0 1 0 -6.28 0 7 7 0 0 0 -5.86 6.9v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9a7 7 0 0 0 -5.86-6.9zm-7.14-5.1a4 4 0 1 1 4 4 4 4 0 0 1 -4-4zm11 20h-14v-8a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m55 47.08a5.25 5.25 0 1 0 -5.92 0 6 6 0 0 0 -5.08 5.92v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a6 6 0 0 0 -5-5.92zm-6.21-4.33a3.25 3.25 0 1 1 3.21 3.25 3.26 3.26 0 0 1 -3.25-3.25zm9.21 17.25h-12v-7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.05 30.32a1 1 0 0 0 1.9 0l1.77-5.32h8.28a2 2 0 0 0 2-2v-20a2 2 0 0 0 -2-2h-22a2 2 0 0 0 -2 2v20a2 2 0 0 0 2 2h8.28zm-10.05-27.32h22v20h-9a1 1 0 0 0 -1 .68l-1 3.16-1-3.16a1 1 0 0 0 -1-.68h-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m61 8h-13v2h13v18h-7.29a1 1 0 0 0 -.92.61l-.79 1.85-.79-1.85a1 1 0 0 0 -.92-.61h-7.29v2h6.63l1.45 3.39a1 1 0 0 0 1.84 0l1.45-3.39h6.63a2 2 0 0 0 2-2v-18a2 2 0 0 0 -2-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38 18v-10a1 1 0 0 0 -1-1h-10a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zm-2-1h-8v-8h3v2h2v-2h3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m52 15v3h-3v2h3v3h2v-3h3v-2h-3v-3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15 47.08a5.25 5.25 0 1 0 -5.92 0 6 6 0 0 0 -5.08 5.92v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a6 6 0 0 0 -5-5.92zm-6.25-4.33a3.25 3.25 0 1 1 3.25 3.25 3.26 3.26 0 0 1 -3.25-3.25zm9.25 17.25h-12v-7a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12.79 28.61-.79 1.85-.79-1.85a1 1 0 0 0 -.92-.61h-7.29v-18h13v-2h-13a2 2 0 0 0 -2 2v18a2 2 0 0 0 2 2h6.63l1.45 3.39a1 1 0 0 0 1.84 0l1.45-3.39h6.63v-2h-7.29a1 1 0 0 0 -.92.61z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m12 23v-3h3v-2h-3v-3h-2v3h-3v2h3v3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersproducts);
export default __webpack_public_path__ + "static/media/customers products.a42b81e8d4a7f20e085a3b7cfd6b9fa5.svg";
export { ForwardRef as ReactComponent };